import $ from "jquery";

class Em {
	constructor() {
		this.dom();
	}

	dom() {
		// Global
		this.$document = $(document);
		this.$window = $(window);
		this.$body = $('body');

		// Header
		this.$header = $('#header');
	}
}

export default Em;
